// extracted by mini-css-extract-plugin
module.exports = {"projectBox__progress":"CustomProgressBar_projectBox__progress__3bbnP","projectBox__progress__progressBar":"CustomProgressBar_projectBox__progress__progressBar__1wssJ"};